import React from 'react';
import './Footer.css'; // Import the CSS file for the Footer component

const Footer = () => {
  return (
    <footer className="footer-container">
      <p className="footer-text"> <span className='orangecolor bold'>© 2023</span> Your Website. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
